import global from "@/locales/sr-BA/global";
import error403 from "@/locales/sr-BA/errors/403";
import error404 from "@/locales/sr-BA/errors/404";
import error500 from "@/locales/sr-BA/errors/500";
import error503 from "@/locales/sr-BA/errors/503";
import error504 from "@/locales/sr-BA/errors/504";
import maintenance from "@/locales/sr-BA/auth/maintenance";
import toast from "@/locales/sr-BA/toast/toast";
import login from "@/locales/sr-BA/auth/login";
import onboarding from "@/locales/sr-BA/auth/onboarding";
import loginPageSteps from "@/locales/sr-BA/loginPageSteps";
import dashboard from "@/locales/sr-BA/dashboard/dashboard";
import account from "@/locales/sr-BA/account/account";
import mailbox from "@/locales/sr-BA/account/mailbox";
import bankstatement from "@/locales/sr-BA/account/bankstatement";
import myApps from "@/locales/sr-BA/my-apps/myApps";
import about from "@/locales/sr-BA/about/about";
import contactService from "@/locales/sr-BA/about/contactService";
import salesPromotions from "@/locales/sr-BA/sales/promotions";
import brochures from "@/locales/sr-BA/sales/brochures";
import shop from "@/locales/sr-BA/shop/data";
import priceList from "@/locales/sr-BA/shop/priceList";
import staff from "@/locales/sr-BA/dashboard/staff";
import promotions from "@/locales/sr-BA/promotions";
import points from "@/locales/sr-BA/points";
import trainings from "@/locales/sr-BA/trainings/trainings";
import vouchers from "@/locales/sr-BA/vouchers/vouchers";
import media from "@/locales/sr-BA/media/index";
import product from "@/locales/sr-BA/product/index";
import message from "@/locales/sr-BA/message/index";
import commitmentLetter from "@/locales/sr-BA/account/commitmentLetter";
import multiplicator from "@/locales/sr-BA/multiplicator";
import consents from "@/locales/sr-BA/consents/consents";
import investment from "@/locales/sr-BA/investment/data";
import kickback from "@/locales/sr-BA/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Slike proizvoda",
    BDriveLinkText: "Link ka portalu SLIKA PROIZVODA",
  },
}

export default {
  locale: "sr-BA",
  messages,
};
